import React from "react";
import styled from "styled-components";
import { convertPxToRem } from "frontend/components/helpers";

import CC from "core/ReusableIcons/CC";
import Tooltip from "core/Tooltip";

export const TooltipText = styled.p`
    display: block;
    margin-bottom: ${convertPxToRem({ px: 8 })};
`;

export default () => (
    <Tooltip
        title="Creative Commons CC BY 3.0"
        clickToOpen
        message={
            <>
                <TooltipText>
                    This icon is licensed as Creative Commons CC BY 3.0
                </TooltipText>
                <TooltipText>
                    When using it for any project, you are required to give
                    credit to the icon's creator or purchase a royalty-free
                    license.
                </TooltipText>
                <a
                    href="https://thenounproject.com/pricing/#icons"
                    target="_blank"
                >
                    Learn more
                </a>
            </>
        }
    >
        <CC />
    </Tooltip>
);
